/**
 * Common utils
 */

define(function(require) {
    'use strict';

    var utils = require('util/common.util');

    utils.closest = function closest(el, fn) {
        return el && (
            fn(el) ? el : closest(el.parentNode, fn)
        );
    };

    return utils;
});
